// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_BACKEND_BASE_URL,
};

// Helper function to get the full API URL
export const getApiUrl = (endpoint = "") => {
  const baseUrl = API_CONFIG.BASE_URL;
  // Remove leading slash from endpoint if present
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint;
  // Ensure proper URL concatenation
  return cleanEndpoint ? `${baseUrl}/${cleanEndpoint}` : baseUrl;
};
